import React, { Component } from 'react';
import './IconAutocomplete.css';

class IconAutocomplete extends Component {
    /**
     * 
     * @param {*} props
     * This class builds address auto complete on the registration page 
     */
    constructor(props) {
        super(props);
        this.state = {
            suggestions: [],
            text: ''
        };
    }

    onTextChanged(input) {
        const { items } = this.props;
        // if input.target exists, assign value to input.target.value
        const value = input.target ? input.target.value : input;
        let suggestions = [];
        // find a list of suggested addresses
        if (value.length > 0) {
            const regex = new RegExp(`^.*${value}.*`, 'i');
            suggestions = items.sort().filter(v => regex.test(v));
        }
        this.props.onChange(value);
        this.setState(() => ({ suggestions, text: value }));
    }

    // when user select an address, place that address in the input box
    suggestionSelected(value) {
        this.props.onChange(value);
        this.setState({
            text: value,
            suggestions: []
        });
    }

    renderSuggestions() {
        const { suggestions } = this.state;
        if (suggestions.length === 0) {
            return null;
        }
        // show the list of suggested addresses
        return (
            <div className='dropdown-item autocomplete-dropdown overflow-auto'>
                <ul >
                    {suggestions.map((item, index) => <li key={index} onClick={() => this.suggestionSelected(item)}>{item}</li>)}
                </ul>
            </div>
        );
    }

    render() {
        return (
            <div>
                <div className='IconAutocomplete input-group mb-3'>
                    <div className='input-group-prepend'>
                        <span
                            className='input-group-text font-weight-bold'
                            id='inputGroup-sizing-default'
                        >
                            <i className={this.props.icon}></i>
                        </span>
                    </div>


                    <input
                        placeholder={this.props.placeholder}
                        autoComplete={this.props.autoComplete}
                        type={this.props.type}
                        className='form-control'
                        value={this.state.text}
                        onChange={(input) => this.onTextChanged(input)}
                    />
                    {this.renderSuggestions()}
                </div>
            </div>
        );
    }
}

export default IconAutocomplete;


// WEBPACK FOOTER //
// ./src/components/icon-autocomplete/index.js